'use es6';

import { ActionTypes } from '../constants/AppConstants';
var defaultState = {
  email: ''
};

var Contact = function Contact() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.STORE_CONTACT:
      if (action.payload && action.payload.contactEmail) {
        return Object.assign({}, state, {
          email: action.payload.contactEmail
        });
      }

      return state;

    default:
      return state;
  }
};

export default Contact;